/*! For license information please see index.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.commandbar = t() : e.commandbar = t();
}(this, () => (() => {
  var e = {
      599: (e, t, r) => {
        "use strict";

        r.r(t), r.d(t, {
          default: () => m,
          getControlKey: () => p
        });
        var o = r(378),
          n = function () {
            return ["WINDOWS", "ANDROID", "LINUX"].includes(function () {
              if ("undefined" != typeof window) {
                var e = window.navigator.userAgent,
                  t = window.navigator.platform,
                  r = "MAC";
                return -1 !== ["Macintosh", "MacIntel", "MacPPC", "Mac68K"].indexOf(t) ? r = "MAC" : -1 !== ["iPhone", "iPad", "iPod"].indexOf(t) ? r = "IOS" : -1 !== ["Win32", "Win64", "Windows", "WinCE"].indexOf(t) ? r = "WINDOWS" : /Android/.test(e) ? r = "ANDROID" : /Linux/.test(t) && (r = "LINUX"), r;
              }
            }()) ? "Ctrl" : "⌘";
          },
          i = {
            color: void 0,
            size: void 0,
            className: void 0,
            style: void 0,
            attr: void 0
          },
          a = o.createContext && o.createContext(i),
          s = function () {
            return s = Object.assign || function (e) {
              for (var t, r = 1, o = arguments.length; r < o; r++) for (var n in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
              return e;
            }, s.apply(this, arguments);
          },
          u = function (e, t) {
            var r = {};
            for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
            if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
              var n = 0;
              for (o = Object.getOwnPropertySymbols(e); n < o.length; n++) t.indexOf(o[n]) < 0 && (r[o[n]] = e[o[n]]);
            }
            return r;
          };
        function c(e) {
          return e && e.map(function (e, t) {
            return o.createElement(e.tag, s({
              key: t
            }, e.attr), c(e.child));
          });
        }
        function l(e) {
          return function (t) {
            return o.createElement(f, s({
              attr: s({}, e.attr)
            }, t), c(e.child));
          };
        }
        function f(e) {
          var t = function (t) {
            var r,
              n = e.size || t.size || "1em";
            t.className && (r = t.className), e.className && (r = (r ? r + " " : "") + e.className);
            var i = e.attr,
              a = e.title,
              c = u(e, ["attr", "title"]);
            return o.createElement("svg", s({
              stroke: "currentColor",
              fill: "currentColor",
              strokeWidth: "0"
            }, t.attr, i, c, {
              className: r,
              style: s({
                color: e.color || t.color
              }, t.style, e.style),
              height: n,
              width: n,
              xmlns: "http://www.w3.org/2000/svg"
            }), a && o.createElement("title", null, a), e.children);
          };
          return void 0 !== a ? o.createElement(a.Consumer, null, function (e) {
            return t(e);
          }) : t(i);
        }
        function d(e) {
          return l({
            tag: "svg",
            attr: {
              viewBox: "0 0 1024 1024"
            },
            child: [{
              tag: "path",
              attr: {
                d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
              }
            }]
          })(e);
        }
        var p = n;
        const m = function (e) {
          var t = e.text,
            r = e.style;
          return o.createElement("div", {
            id: "commandbar-user-launcher-component",
            className: "commandbar-user-launcher",
            style: r || {},
            onClick: function () {
              var e, t;
              null === (e = window) || void 0 === e || null === (t = e.CommandBar) || void 0 === t || t.open();
            }
          }, o.createElement("div", {
            className: "commandbar-user-launcher__content"
          }, o.createElement("div", {
            className: "commandbar-user-launcher__prefix"
          }, o.createElement(d, null), "  ", t || "Find anything"), !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && o.createElement("div", {
            className: "commandbar-user-launcher__suffix"
          }, o.createElement("span", {
            style: {
              marginRight: 3
            },
            className: "commandbar-user-launcher__tag"
          }, n()), o.createElement("span", {
            style: {
              marginRight: 3
            }
          }, "+"), o.createElement("span", {
            className: "commandbar-user-launcher__tag "
          }, "K"))));
        };
      },
      296: (e, t, r) => {
        "use strict";

        var o = r(102),
          n = r(307),
          i = r(339),
          a = r(957),
          s = r(246);
        (e.exports = function (e, t) {
          var r, n, u, c, l;
          return arguments.length < 2 || "string" != typeof e ? (c = t, t = e, e = null) : c = arguments[2], o(e) ? (r = s.call(e, "c"), n = s.call(e, "e"), u = s.call(e, "w")) : (r = u = !0, n = !1), l = {
            value: t,
            configurable: r,
            enumerable: n,
            writable: u
          }, c ? i(a(c), l) : l;
        }).gs = function (e, t, r) {
          var u, c, l, f;
          return "string" != typeof e ? (l = r, r = t, t = e, e = null) : l = arguments[3], o(t) ? n(t) ? o(r) ? n(r) || (l = r, r = void 0) : r = void 0 : (l = t, t = r = void 0) : t = void 0, o(e) ? (u = s.call(e, "c"), c = s.call(e, "e")) : (u = !0, c = !1), f = {
            get: t,
            set: r,
            configurable: u,
            enumerable: c
          }, l ? i(a(l), f) : f;
        };
      },
      817: e => {
        "use strict";

        e.exports = function () {};
      },
      339: (e, t, r) => {
        "use strict";

        e.exports = r(994)() ? Object.assign : r(963);
      },
      994: e => {
        "use strict";

        e.exports = function () {
          var e,
            t = Object.assign;
          return "function" == typeof t && (t(e = {
            foo: "raz"
          }, {
            bar: "dwa"
          }, {
            trzy: "trzy"
          }), e.foo + e.bar + e.trzy === "razdwatrzy");
        };
      },
      963: (e, t, r) => {
        "use strict";

        var o = r(450),
          n = r(836),
          i = Math.max;
        e.exports = function (e, t) {
          var r,
            a,
            s,
            u = i(arguments.length, 2);
          for (e = Object(n(e)), s = function (o) {
            try {
              e[o] = t[o];
            } catch (e) {
              r || (r = e);
            }
          }, a = 1; a < u; ++a) o(t = arguments[a]).forEach(s);
          if (void 0 !== r) throw r;
          return e;
        };
      },
      349: (e, t, r) => {
        "use strict";

        var o = r(817)();
        e.exports = function (e) {
          return e !== o && null !== e;
        };
      },
      450: (e, t, r) => {
        "use strict";

        e.exports = r(446)() ? Object.keys : r(177);
      },
      446: e => {
        "use strict";

        e.exports = function () {
          try {
            return Object.keys("primitive"), !0;
          } catch (e) {
            return !1;
          }
        };
      },
      177: (e, t, r) => {
        "use strict";

        var o = r(349),
          n = Object.keys;
        e.exports = function (e) {
          return n(o(e) ? Object(e) : e);
        };
      },
      957: (e, t, r) => {
        "use strict";

        var o = r(349),
          n = Array.prototype.forEach,
          i = Object.create;
        e.exports = function (e) {
          var t = i(null);
          return n.call(arguments, function (e) {
            o(e) && function (e, t) {
              var r;
              for (r in e) t[r] = e[r];
            }(Object(e), t);
          }), t;
        };
      },
      836: (e, t, r) => {
        "use strict";

        var o = r(349);
        e.exports = function (e) {
          if (!o(e)) throw new TypeError("Cannot use null or undefined");
          return e;
        };
      },
      246: (e, t, r) => {
        "use strict";

        e.exports = r(711)() ? String.prototype.contains : r(370);
      },
      711: e => {
        "use strict";

        var t = "razdwatrzy";
        e.exports = function () {
          return "function" == typeof t.contains && !0 === t.contains("dwa") && !1 === t.contains("foo");
        };
      },
      370: e => {
        "use strict";

        var t = String.prototype.indexOf;
        e.exports = function (e) {
          return t.call(this, e, arguments[1]) > -1;
        };
      },
      992: (e, t, r) => {
        "use strict";

        r(98).polyfill();
      },
      98: e => {
        "use strict";

        function t(e, t) {
          if (null == e) throw new TypeError("Cannot convert first argument to object");
          for (var r = Object(e), o = 1; o < arguments.length; o++) {
            var n = arguments[o];
            if (null != n) for (var i = Object.keys(Object(n)), a = 0, s = i.length; a < s; a++) {
              var u = i[a],
                c = Object.getOwnPropertyDescriptor(n, u);
              void 0 !== c && c.enumerable && (r[u] = n[u]);
            }
          }
          return r;
        }
        e.exports = {
          assign: t,
          polyfill: function () {
            Object.assign || Object.defineProperty(Object, "assign", {
              enumerable: !1,
              configurable: !0,
              writable: !0,
              value: t
            });
          }
        };
      },
      769: (e, t, r) => {
        "use strict";

        r(614)() || Object.defineProperty(r(119), "Symbol", {
          value: r(798),
          configurable: !0,
          enumerable: !1,
          writable: !0
        });
      },
      614: (e, t, r) => {
        "use strict";

        var o = r(119),
          n = {
            object: !0,
            symbol: !0
          };
        e.exports = function () {
          var e,
            t = o.Symbol;
          if ("function" != typeof t) return !1;
          e = t("test symbol");
          try {
            String(e);
          } catch (e) {
            return !1;
          }
          return !!n[typeof t.iterator] && !!n[typeof t.toPrimitive] && !!n[typeof t.toStringTag];
        };
      },
      64: e => {
        "use strict";

        e.exports = function (e) {
          return !!e && ("symbol" == typeof e || !!e.constructor && "Symbol" === e.constructor.name && "Symbol" === e[e.constructor.toStringTag]);
        };
      },
      573: (e, t, r) => {
        "use strict";

        var o = r(296),
          n = Object.create,
          i = Object.defineProperty,
          a = Object.prototype,
          s = n(null);
        e.exports = function (e) {
          for (var t, r, n = 0; s[e + (n || "")];) ++n;
          return s[e += n || ""] = !0, i(a, t = "@@" + e, o.gs(null, function (e) {
            r || (r = !0, i(this, t, o(e)), r = !1);
          })), t;
        };
      },
      572: (e, t, r) => {
        "use strict";

        var o = r(296),
          n = r(119).Symbol;
        e.exports = function (e) {
          return Object.defineProperties(e, {
            hasInstance: o("", n && n.hasInstance || e("hasInstance")),
            isConcatSpreadable: o("", n && n.isConcatSpreadable || e("isConcatSpreadable")),
            iterator: o("", n && n.iterator || e("iterator")),
            match: o("", n && n.match || e("match")),
            replace: o("", n && n.replace || e("replace")),
            search: o("", n && n.search || e("search")),
            species: o("", n && n.species || e("species")),
            split: o("", n && n.split || e("split")),
            toPrimitive: o("", n && n.toPrimitive || e("toPrimitive")),
            toStringTag: o("", n && n.toStringTag || e("toStringTag")),
            unscopables: o("", n && n.unscopables || e("unscopables"))
          });
        };
      },
      781: (e, t, r) => {
        "use strict";

        var o = r(296),
          n = r(11),
          i = Object.create(null);
        e.exports = function (e) {
          return Object.defineProperties(e, {
            for: o(function (t) {
              return i[t] ? i[t] : i[t] = e(String(t));
            }),
            keyFor: o(function (e) {
              var t;
              for (t in n(e), i) if (i[t] === e) return t;
            })
          });
        };
      },
      798: (e, t, r) => {
        "use strict";

        var o,
          n,
          i,
          a = r(296),
          s = r(11),
          u = r(119).Symbol,
          c = r(573),
          l = r(572),
          f = r(781),
          d = Object.create,
          p = Object.defineProperties,
          m = Object.defineProperty;
        if ("function" == typeof u) try {
          String(u()), i = !0;
        } catch (e) {} else u = null;
        n = function (e) {
          if (this instanceof n) throw new TypeError("Symbol is not a constructor");
          return o(e);
        }, e.exports = o = function e(t) {
          var r;
          if (this instanceof e) throw new TypeError("Symbol is not a constructor");
          return i ? u(t) : (r = d(n.prototype), t = void 0 === t ? "" : String(t), p(r, {
            __description__: a("", t),
            __name__: a("", c(t))
          }));
        }, l(o), f(o), p(n.prototype, {
          constructor: a(o),
          toString: a("", function () {
            return this.__name__;
          })
        }), p(o.prototype, {
          toString: a(function () {
            return "Symbol (" + s(this).__description__ + ")";
          }),
          valueOf: a(function () {
            return s(this);
          })
        }), m(o.prototype, o.toPrimitive, a("", function () {
          var e = s(this);
          return "symbol" == typeof e ? e : e.toString();
        })), m(o.prototype, o.toStringTag, a("c", "Symbol")), m(n.prototype, o.toStringTag, a("c", o.prototype[o.toStringTag])), m(n.prototype, o.toPrimitive, a("c", o.prototype[o.toPrimitive]));
      },
      11: (e, t, r) => {
        "use strict";

        var o = r(64);
        e.exports = function (e) {
          if (!o(e)) throw new TypeError(e + " is not a symbol");
          return e;
        };
      },
      308: e => {
        var t = function () {
          if ("object" == typeof self && self) return self;
          if ("object" == typeof window && window) return window;
          throw new Error("Unable to resolve global `this`");
        };
        e.exports = function () {
          if (this) return this;
          try {
            Object.defineProperty(Object.prototype, "__global__", {
              get: function () {
                return this;
              },
              configurable: !0
            });
          } catch (e) {
            return t();
          }
          try {
            return __global__ || t();
          } finally {
            delete Object.prototype.__global__;
          }
        }();
      },
      119: (e, t, r) => {
        "use strict";

        e.exports = r(801)() ? globalThis : r(308);
      },
      801: e => {
        "use strict";

        e.exports = function () {
          return "object" == typeof globalThis && !!globalThis && globalThis.Array === Array;
        };
      },
      525: e => {
        "use strict";

        var t = Object.getOwnPropertySymbols,
          r = Object.prototype.hasOwnProperty,
          o = Object.prototype.propertyIsEnumerable;
        e.exports = function () {
          try {
            if (!Object.assign) return !1;
            var e = new String("abc");
            if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
            for (var t = {}, r = 0; r < 10; r++) t["_" + String.fromCharCode(r)] = r;
            if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
              return t[e];
            }).join("")) return !1;
            var o = {};
            return "abcdefghijklmnopqrst".split("").forEach(function (e) {
              o[e] = e;
            }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
          } catch (e) {
            return !1;
          }
        }() ? Object.assign : function (e, n) {
          for (var i, a, s = function (e) {
              if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
              return Object(e);
            }(e), u = 1; u < arguments.length; u++) {
            for (var c in i = Object(arguments[u])) r.call(i, c) && (s[c] = i[c]);
            if (t) {
              a = t(i);
              for (var l = 0; l < a.length; l++) o.call(i, a[l]) && (s[a[l]] = i[a[l]]);
            }
          }
          return s;
        };
      },
      656: (e, t, r) => {
        "use strict";

        var o;
        (o = "undefined" != typeof process && "[object process]" === {}.toString.call(process) || "undefined" != typeof navigator && "ReactNative" === navigator.product ? r.g : self).Proxy || (o.Proxy = r(659)(), o.Proxy.revocable = o.Proxy.revocable);
      },
      659: e => {
        e.exports = function () {
          let e,
            t = null;
          function r(e) {
            return !!e && ("object" == typeof e || "function" == typeof e);
          }
          function o(e) {
            if (null !== e && !r(e)) throw new TypeError("Object prototype may only be an Object or null: " + e);
          }
          const n = Object,
            i = Boolean(n.create) || !({
              __proto__: null
            } instanceof n),
            a = n.create || (i ? function (e) {
              return o(e), {
                __proto__: e
              };
            } : function (e) {
              if (o(e), null === e) throw new SyntaxError("Native Object.create is required to create objects with null prototype");
              var t = function () {};
              return t.prototype = e, new t();
            }),
            s = function () {
              return null;
            },
            u = n.getPrototypeOf || ([].__proto__ === Array.prototype ? function (e) {
              const t = e.__proto__;
              return r(t) ? t : null;
            } : s);
          return e = function (c, l) {
            if (void 0 === (this && this instanceof e ? this.constructor : void 0)) throw new TypeError("Constructor Proxy requires 'new'");
            if (!r(c) || !r(l)) throw new TypeError("Cannot create proxy with a non-object as target or handler");
            let f = function () {};
            t = function () {
              c = null, f = function (e) {
                throw new TypeError(`Cannot perform '${e}' on a proxy that has been revoked`);
              };
            }, setTimeout(function () {
              t = null;
            }, 0);
            const d = l;
            l = {
              get: null,
              set: null,
              apply: null,
              construct: null
            };
            for (let e in d) {
              if (!(e in l)) throw new TypeError(`Proxy polyfill does not support trap '${e}'`);
              l[e] = d[e];
            }
            "function" == typeof d && (l.apply = d.apply.bind(d));
            const p = u(c);
            let m,
              y = !1,
              b = !1;
            "function" == typeof c ? (m = function () {
              const e = this && this.constructor === m,
                t = Array.prototype.slice.call(arguments);
              return f(e ? "construct" : "apply"), e && l.construct ? l.construct.call(this, c, t) : !e && l.apply ? l.apply(c, this, t) : e ? (t.unshift(c), new (c.bind.apply(c, t))()) : c.apply(this, t);
            }, y = !0) : c instanceof Array ? (m = [], b = !0) : m = i || null !== p ? a(p) : {};
            const _ = l.get ? function (e) {
                return f("get"), l.get(this, e, m);
              } : function (e) {
                return f("get"), this[e];
              },
              v = l.set ? function (e, t) {
                f("set"), l.set(this, e, t, m);
              } : function (e, t) {
                f("set"), this[e] = t;
              },
              h = n.getOwnPropertyNames(c),
              g = {};
            h.forEach(function (e) {
              if ((y || b) && e in m) return;
              const t = n.getOwnPropertyDescriptor(c, e),
                r = {
                  enumerable: Boolean(t.enumerable),
                  get: _.bind(c, e),
                  set: v.bind(c, e)
                };
              n.defineProperty(m, e, r), g[e] = !0;
            });
            let S = !0;
            if (y || b) {
              const e = n.setPrototypeOf || ([].__proto__ === Array.prototype ? function (e, t) {
                return o(t), e.__proto__ = t, e;
              } : s);
              p && e(m, p) || (S = !1);
            }
            if (l.get || !S) for (let e in c) g[e] || n.defineProperty(m, e, {
              get: _.bind(c, e)
            });
            return n.seal(c), n.seal(m), m;
          }, e.revocable = function (r, o) {
            return {
              proxy: new e(r, o),
              revoke: t
            };
          }, e;
        };
      },
      535: (e, t, r) => {
        "use strict";

        var o = r(525),
          n = 60103,
          i = 60106;
        t.Fragment = 60107, t.StrictMode = 60108, t.Profiler = 60114;
        var a = 60109,
          s = 60110,
          u = 60112;
        t.Suspense = 60113;
        var c = 60115,
          l = 60116;
        if ("function" == typeof Symbol && Symbol.for) {
          var f = Symbol.for;
          n = f("react.element"), i = f("react.portal"), t.Fragment = f("react.fragment"), t.StrictMode = f("react.strict_mode"), t.Profiler = f("react.profiler"), a = f("react.provider"), s = f("react.context"), u = f("react.forward_ref"), t.Suspense = f("react.suspense"), c = f("react.memo"), l = f("react.lazy");
        }
        var d = "function" == typeof Symbol && Symbol.iterator;
        function p(e) {
          for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 1; r < arguments.length; r++) t += "&args[]=" + encodeURIComponent(arguments[r]);
          return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
        }
        var m = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {}
          },
          y = {};
        function b(e, t, r) {
          this.props = e, this.context = t, this.refs = y, this.updater = r || m;
        }
        function _() {}
        function v(e, t, r) {
          this.props = e, this.context = t, this.refs = y, this.updater = r || m;
        }
        b.prototype.isReactComponent = {}, b.prototype.setState = function (e, t) {
          if ("object" != typeof e && "function" != typeof e && null != e) throw Error(p(85));
          this.updater.enqueueSetState(this, e, t, "setState");
        }, b.prototype.forceUpdate = function (e) {
          this.updater.enqueueForceUpdate(this, e, "forceUpdate");
        }, _.prototype = b.prototype;
        var h = v.prototype = new _();
        h.constructor = v, o(h, b.prototype), h.isPureReactComponent = !0;
        var g = {
            current: null
          },
          S = Object.prototype.hasOwnProperty,
          C = {
            key: !0,
            ref: !0,
            __self: !0,
            __source: !0
          };
        function w(e, t, r) {
          var o,
            i = {},
            a = null,
            s = null;
          if (null != t) for (o in void 0 !== t.ref && (s = t.ref), void 0 !== t.key && (a = "" + t.key), t) S.call(t, o) && !C.hasOwnProperty(o) && (i[o] = t[o]);
          var u = arguments.length - 2;
          if (1 === u) i.children = r;else if (1 < u) {
            for (var c = Array(u), l = 0; l < u; l++) c[l] = arguments[l + 2];
            i.children = c;
          }
          if (e && e.defaultProps) for (o in u = e.defaultProps) void 0 === i[o] && (i[o] = u[o]);
          return {
            $$typeof: n,
            type: e,
            key: a,
            ref: s,
            props: i,
            _owner: g.current
          };
        }
        function O(e) {
          return "object" == typeof e && null !== e && e.$$typeof === n;
        }
        var P = /\/+/g;
        function j(e, t) {
          return "object" == typeof e && null !== e && null != e.key ? function (e) {
            var t = {
              "=": "=0",
              ":": "=2"
            };
            return "$" + e.replace(/[=:]/g, function (e) {
              return t[e];
            });
          }("" + e.key) : t.toString(36);
        }
        function E(e, t, r, o, a) {
          var s = typeof e;
          "undefined" !== s && "boolean" !== s || (e = null);
          var u = !1;
          if (null === e) u = !0;else switch (s) {
            case "string":
            case "number":
              u = !0;
              break;
            case "object":
              switch (e.$$typeof) {
                case n:
                case i:
                  u = !0;
              }
          }
          if (u) return a = a(u = e), e = "" === o ? "." + j(u, 0) : o, Array.isArray(a) ? (r = "", null != e && (r = e.replace(P, "$&/") + "/"), E(a, t, r, "", function (e) {
            return e;
          })) : null != a && (O(a) && (a = function (e, t) {
            return {
              $$typeof: n,
              type: e.type,
              key: t,
              ref: e.ref,
              props: e.props,
              _owner: e._owner
            };
          }(a, r + (!a.key || u && u.key === a.key ? "" : ("" + a.key).replace(P, "$&/") + "/") + e)), t.push(a)), 1;
          if (u = 0, o = "" === o ? "." : o + ":", Array.isArray(e)) for (var c = 0; c < e.length; c++) {
            var l = o + j(s = e[c], c);
            u += E(s, t, r, l, a);
          } else if (l = function (e) {
            return null === e || "object" != typeof e ? null : "function" == typeof (e = d && e[d] || e["@@iterator"]) ? e : null;
          }(e), "function" == typeof l) for (e = l.call(e), c = 0; !(s = e.next()).done;) u += E(s = s.value, t, r, l = o + j(s, c++), a);else if ("object" === s) throw t = "" + e, Error(p(31, "[object Object]" === t ? "object with keys {" + Object.keys(e).join(", ") + "}" : t));
          return u;
        }
        function B(e, t, r) {
          if (null == e) return e;
          var o = [],
            n = 0;
          return E(e, o, "", "", function (e) {
            return t.call(r, e, n++);
          }), o;
        }
        function x(e) {
          if (-1 === e._status) {
            var t = e._result;
            t = t(), e._status = 0, e._result = t, t.then(function (t) {
              0 === e._status && (t = t.default, e._status = 1, e._result = t);
            }, function (t) {
              0 === e._status && (e._status = 2, e._result = t);
            });
          }
          if (1 === e._status) return e._result;
          throw e._result;
        }
        var T = {
          current: null
        };
        function D() {
          var e = T.current;
          if (null === e) throw Error(p(321));
          return e;
        }
        var k = {
          ReactCurrentDispatcher: T,
          ReactCurrentBatchConfig: {
            transition: 0
          },
          ReactCurrentOwner: g,
          IsSomeRendererActing: {
            current: !1
          },
          assign: o
        };
        t.Children = {
          map: B,
          forEach: function (e, t, r) {
            B(e, function () {
              t.apply(this, arguments);
            }, r);
          },
          count: function (e) {
            var t = 0;
            return B(e, function () {
              t++;
            }), t;
          },
          toArray: function (e) {
            return B(e, function (e) {
              return e;
            }) || [];
          },
          only: function (e) {
            if (!O(e)) throw Error(p(143));
            return e;
          }
        }, t.Component = b, t.PureComponent = v, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = k, t.cloneElement = function (e, t, r) {
          if (null == e) throw Error(p(267, e));
          var i = o({}, e.props),
            a = e.key,
            s = e.ref,
            u = e._owner;
          if (null != t) {
            if (void 0 !== t.ref && (s = t.ref, u = g.current), void 0 !== t.key && (a = "" + t.key), e.type && e.type.defaultProps) var c = e.type.defaultProps;
            for (l in t) S.call(t, l) && !C.hasOwnProperty(l) && (i[l] = void 0 === t[l] && void 0 !== c ? c[l] : t[l]);
          }
          var l = arguments.length - 2;
          if (1 === l) i.children = r;else if (1 < l) {
            c = Array(l);
            for (var f = 0; f < l; f++) c[f] = arguments[f + 2];
            i.children = c;
          }
          return {
            $$typeof: n,
            type: e.type,
            key: a,
            ref: s,
            props: i,
            _owner: u
          };
        }, t.createContext = function (e, t) {
          return void 0 === t && (t = null), (e = {
            $$typeof: s,
            _calculateChangedBits: t,
            _currentValue: e,
            _currentValue2: e,
            _threadCount: 0,
            Provider: null,
            Consumer: null
          }).Provider = {
            $$typeof: a,
            _context: e
          }, e.Consumer = e;
        }, t.createElement = w, t.createFactory = function (e) {
          var t = w.bind(null, e);
          return t.type = e, t;
        }, t.createRef = function () {
          return {
            current: null
          };
        }, t.forwardRef = function (e) {
          return {
            $$typeof: u,
            render: e
          };
        }, t.isValidElement = O, t.lazy = function (e) {
          return {
            $$typeof: l,
            _payload: {
              _status: -1,
              _result: e
            },
            _init: x
          };
        }, t.memo = function (e, t) {
          return {
            $$typeof: c,
            type: e,
            compare: void 0 === t ? null : t
          };
        }, t.useCallback = function (e, t) {
          return D().useCallback(e, t);
        }, t.useContext = function (e, t) {
          return D().useContext(e, t);
        }, t.useDebugValue = function () {}, t.useEffect = function (e, t) {
          return D().useEffect(e, t);
        }, t.useImperativeHandle = function (e, t, r) {
          return D().useImperativeHandle(e, t, r);
        }, t.useLayoutEffect = function (e, t) {
          return D().useLayoutEffect(e, t);
        }, t.useMemo = function (e, t) {
          return D().useMemo(e, t);
        }, t.useReducer = function (e, t, r) {
          return D().useReducer(e, t, r);
        }, t.useRef = function (e) {
          return D().useRef(e);
        }, t.useState = function (e) {
          return D().useState(e);
        }, t.version = "17.0.2";
      },
      378: (e, t, r) => {
        "use strict";

        e.exports = r(535);
      },
      14: function (e, t, r) {
        "use strict";

        var o = this && this.__createBinding || (Object.create ? function (e, t, r, o) {
            void 0 === o && (o = r);
            var n = Object.getOwnPropertyDescriptor(t, r);
            n && !("get" in n ? !t.__esModule : n.writable || n.configurable) || (n = {
              enumerable: !0,
              get: function () {
                return t[r];
              }
            }), Object.defineProperty(e, o, n);
          } : function (e, t, r, o) {
            void 0 === o && (o = r), e[o] = t[r];
          }),
          n = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          i = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && o(t, e, r);
            return n(t, e), t;
          },
          a = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getControlKey = t.Launcher = t.snippet = t.initProxy = t.init = void 0;
        var s = i(r(599));
        t.Launcher = s.default, Object.defineProperty(t, "getControlKey", {
          enumerable: !0,
          get: function () {
            return s.getControlKey;
          }
        });
        var u = r(956);
        Object.defineProperty(t, "init", {
          enumerable: !0,
          get: function () {
            return a(u).default;
          }
        });
        var c = r(737);
        Object.defineProperty(t, "initProxy", {
          enumerable: !0,
          get: function () {
            return c.initProxySDK;
          }
        });
        var l = r(890);
        Object.defineProperty(t, "snippet", {
          enumerable: !0,
          get: function () {
            return l.snippet;
          }
        });
      },
      956: function (e, t, r) {
        "use strict";

        var o = this && this.__assign || function () {
          return o = Object.assign || function (e) {
            for (var t, r = 1, o = arguments.length; r < o; r++) for (var n in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            return e;
          }, o.apply(this, arguments);
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), r(656), r(992), r(769);
        var n = r(737),
          i = r(207),
          a = function (e, t) {
            if ("complete" === document.readyState) {
              var r = function (e, t) {
                  var r = "https://api.commandbar.com",
                    o = [],
                    n = localStorage.getItem("commandbar.lc");
                  n && n.includes("local") && (r = "http://localhost:8000");
                  var i = r + "/latest/" + e;
                  return n && o.push("lc=" + n), t && o.push("nonce=" + encodeURIComponent(t)), o.push("version=2"), i + "?" + o.join("&");
                }(e, t),
                o = document.createElement("script");
              o.type = "text/javascript", o.async = !0, o.src = r, document.head.appendChild(o);
            } else window.addEventListener("load", a.bind(null, e, t), {
              capture: !1,
              once: !0
            });
          },
          s = {
            debug: !1
          };
        t.default = function (e, t) {
          var r;
          void 0 === t && (t = s);
          var u = o(o({}, s), t);
          e ? (null === (r = (0, n.getProxySDK)()[i._configuration]) || void 0 === r ? void 0 : r.uuid) ? console.warn("CommandBar init was called more than once. Skipping the redundant initialization...") : (u.debug && console.log("CommandBar init...", {
            environment: t.environment,
            version: t.version
          }), (0, n.getProxySDK)()[i._configuration] = {
            uuid: e,
            environment: t.environment,
            version: t.version,
            config: t.config,
            nonce: t.nonce
          }, a(e, t.nonce)) : console.error("No org specified for CommandBar.init");
        };
      },
      890: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.snippet = void 0, t.snippet = function (e) {
          var t = ["Object.assign", "Symbol", "Symbol.for"].join("%2C"),
            r = window;
          function o(e, t) {
            void 0 === t && (t = !1), "complete" !== document.readyState && window.addEventListener("load", o.bind(null, e, t), {
              capture: !1,
              once: !0
            });
            var r = document.createElement("script");
            r.type = "text/javascript", r.async = t, r.src = e, document.head.appendChild(r);
          }
          function n() {
            var t;
            if (void 0 === r.CommandBar) {
              delete r.__CommandBarBootstrap__;
              var n = Symbol.for("CommandBar::configuration"),
                i = Symbol.for("CommandBar::orgConfig"),
                a = Symbol.for("CommandBar::disposed"),
                s = Symbol.for("CommandBar::isProxy"),
                u = Symbol.for("CommandBar::queue"),
                c = Symbol.for("CommandBar::unwrap"),
                l = Symbol.for("CommandBar::eventSubscriptions"),
                f = [],
                d = localStorage.getItem("commandbar.lc"),
                p = d && d.includes("local") ? "http://localhost:8000" : "https://api.commandbar.com",
                m = Object.assign(((t = {})[n] = {
                  uuid: e
                }, t[i] = {}, t[a] = !1, t[s] = !0, t[u] = new Array(), t[c] = function () {
                  return m;
                }, t[l] = void 0, t), r.CommandBar),
                y = ["addCommand", "boot", "addEventSubscriber", "addRecordAction", "setFormFactor"],
                b = m;
              Object.assign(m, {
                shareCallbacks: function () {
                  return {};
                },
                shareContext: function () {
                  return {};
                }
              }), r.CommandBar = new Proxy(m, {
                get: function (e, t) {
                  return t in b ? m[t] : "then" !== t ? y.includes(t) ? function () {
                    var e = Array.prototype.slice.call(arguments);
                    return new Promise(function (r, o) {
                      e.unshift(t, r, o), m[u].push(e);
                    });
                  } : function () {
                    var e = Array.prototype.slice.call(arguments);
                    e.unshift(t), m[u].push(e);
                  } : void 0;
                }
              }), null !== d && f.push("lc=".concat(d)), f.push("version=2"), o("".concat(p, "/latest/").concat(e, "?").concat(f.join("&")), !0);
            }
          }
          void 0 === Object.assign || "undefined" == typeof Symbol || void 0 === Symbol.for ? (r.__CommandBarBootstrap__ = n, o("https://polyfill.io/v3/polyfill.min.js?version=3.101.0&callback=__CommandBarBootstrap__&features=" + t)) : n();
        };
      },
      343: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.DEFAULT_META_ATTRIBUTES = t.DEFAULT_INSTANCE_ATTRIBUTES = t.PRODUCTS = t.ASYNC_METHODS = t.ASYNC_METHODS_SNIPPET = void 0, t.ASYNC_METHODS_SNIPPET = ["addCommand", "boot", "addEventSubscriber", "addRecordAction", "setFormFactor"], t.ASYNC_METHODS = ["addCommand", "boot", "addEventSubscriber", "addEventHandler", "addRecordAction", "setFormFactor"], t.PRODUCTS = ["spotlight", "nudges", "checklists", "help_hub"], t.DEFAULT_INSTANCE_ATTRIBUTES = {
          canOpenEditor: !0,
          formFactor: {
            type: "modal"
          },
          products: ["spotlight", "nudges", "checklists", "help_hub"]
        }, t.DEFAULT_META_ATTRIBUTES = {};
      },
      737: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.initProxySDK = t.getProxySDK = void 0;
        var o = r(314),
          n = r(343),
          i = r(207);
        function a() {
          var e,
            t,
            r,
            o,
            a = window.CommandBar,
            s = window.CommandBar;
          Array.isArray(null == a ? void 0 : a.q) || "string" == typeof (null == a ? void 0 : a.uid) ? (r = null == a ? void 0 : a.uid, o = null == a ? void 0 : a.q) : (r = null === (t = null == s ? void 0 : s[i._configuration]) || void 0 === t ? void 0 : t.uuid, o = null == s ? void 0 : s[i._queue]);
          var u = ((e = {})[i._configuration] = {
              uuid: "string" == typeof r ? r : ""
            }, e[i._disposed] = !1, e[i._isProxy] = !0, e[i._queue] = Array.isArray(o) ? o : [], e[i._unwrap] = function () {
              return u;
            }, e[i._eventSubscriptions] = void 0, e[i._sentry] = void 0, e),
            c = u;
          Object.assign(u, {
            shareCallbacks: function () {
              return {};
            },
            shareContext: function () {
              return {};
            }
          }), window.CommandBar = new Proxy(u, {
            get: function (e, t) {
              return t in c ? c[t] : "then" !== t ? n.ASYNC_METHODS_SNIPPET.includes(t) ? function () {
                var e = Array.prototype.slice.call(arguments);
                return new Promise(function (r, o) {
                  e.unshift(t, r, o), u[i._queue].push(e);
                });
              } : function () {
                var e = Array.prototype.slice.call(arguments);
                e.unshift(t), u[i._queue].push(e);
              } : void 0;
            }
          });
        }
        t.getProxySDK = function () {
          var e = window.CommandBar;
          return ((0, o.isDisposed)(e) || "boolean" != typeof e[i._isProxy]) && a(), window.CommandBar[i._unwrap]();
        }, t.initProxySDK = a;
      },
      207: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t._fingerprint = t._user = t._unwrap = t._state = t._showMessage = t._showGuide = t._shareProgrammaticCommands = t._shareContextSettings = t._shareConfig = t._setEditorVisible = t._setTestMode = t._setPreviewMode = t._setDashboard = t._sentry = t._search = t._report = t._reloadChecklists = t._previewChecklist = t._stopNudgeDebug = t._stopChecklistPreview = t._closeNudgeMocks = t._showNudgeStepMock = t._getDebugSnapshot = t._startNudgeDebug = t._stopRecommendationSetPreview = t._previewCopilotSettings = t._previewRecommendationSet = t._reloadHelpHub = t._reloadNudges = t._reloadPlaceholders = t._reloadOrganization = t._reloadCommands = t._reload = t._queue = t._programmaticTheme = t._perf = t._orgConfig = t._getEditorPreviewDevice = t._updateEditorPreviewDevice = t._shareEditorRouteWithBar = t._onEditorPathChange = t._loadEditor = t._isProxy = t._instanceAttributes = t._disposed = t._dispose = t._dispatch = t._configUser = t._configure = t._configuration = void 0, t._showWidgetTableau = t._setThemeV2 = t._shareTrackedEvents = t._stopDebug = t._startDebug = t._updateEditorRoute = t._metaAttributes = t._eventSubscriptions = t._userProperties = void 0, t._configuration = Symbol.for("CommandBar::configuration"), t._configure = Symbol.for("CommandBar::configure"), t._configUser = Symbol.for("CommandBar::configUser"), t._dispatch = Symbol.for("CommandBar::dispatch"), t._dispose = Symbol.for("CommandBar::dispose"), t._disposed = Symbol.for("CommandBar::disposed"), t._instanceAttributes = Symbol.for("CommandBar::instanceAttributes"), t._isProxy = Symbol.for("CommandBar::isProxy"), t._loadEditor = Symbol.for("CommandBar::loadEditor"), t._onEditorPathChange = Symbol.for("CommandBar::onEditorPathChange"), t._shareEditorRouteWithBar = Symbol.for("CommandBar::shareEditorRouteWithBar"), t._updateEditorPreviewDevice = Symbol.for("CommandBar::updateEditorPreviewDevice"), t._getEditorPreviewDevice = Symbol.for("CommandBar::getEditorPreviewDevice"), t._orgConfig = Symbol.for("CommandBar::orgConfig"), t._perf = Symbol.for("CommandBar::perf"), t._programmaticTheme = Symbol.for("CommandBar::programmaticTheme"), t._queue = Symbol.for("CommandBar::queue"), t._reload = Symbol.for("CommandBar::reload"), t._reloadCommands = Symbol.for("CommandBar::reloadCommands"), t._reloadOrganization = Symbol.for("CommandBar::reloadOrganization"), t._reloadPlaceholders = Symbol.for("CommandBar::reloadPlaceholders"), t._reloadNudges = Symbol.for("CommandBar::reloadNudges"), t._reloadHelpHub = Symbol.for("CommandBar::reloadHelpHub"), t._previewRecommendationSet = Symbol.for("CommandBar::previewRecommendationSet"), t._previewCopilotSettings = Symbol.for("CommandBar::previewCopilotSettings"), t._stopRecommendationSetPreview = Symbol.for("CommandBar::stopRecommendationSetPreview"), t._startNudgeDebug = Symbol.for("CommandBar::startNudgeDebug"), t._getDebugSnapshot = Symbol.for("CommandBar::getDebugSnapshot"), t._showNudgeStepMock = Symbol.for("CommandBar::showNudgeStepMock"), t._closeNudgeMocks = Symbol.for("CommandBar::closeNudgeMocks"), t._stopChecklistPreview = Symbol.for("CommandBar::stopChecklistPreview"), t._stopNudgeDebug = Symbol.for("CommandBar::stopNudgeDebug"), t._previewChecklist = Symbol.for("CommandBar::previewChecklist"), t._reloadChecklists = Symbol.for("CommandBar::reloadChecklists"), t._report = Symbol.for("CommandBar::report"), t._search = Symbol.for("CommandBar::search"), t._sentry = Symbol.for("CommandBar::sentry"), t._setDashboard = Symbol.for("CommandBar::setDashboard"), t._setPreviewMode = Symbol.for("CommandBar::setPreviewMode"), t._setTestMode = Symbol.for("CommandBar::setTestMode"), t._setEditorVisible = Symbol.for("CommandBar::setEditorVisible"), t._shareConfig = Symbol.for("CommandBar::shareConfig"), t._shareContextSettings = Symbol.for("CommandBar::shareContextSettings"), t._shareProgrammaticCommands = Symbol.for("CommandBar::shareProgrammaticCommands"), t._showGuide = Symbol.for("CommandBar::showGuide"), t._showMessage = Symbol.for("CommandBar::showMessage"), t._state = Symbol.for("CommandBar::state"), t._unwrap = Symbol.for("CommandBar::unwrap"), t._user = Symbol.for("CommandBar::user"), t._fingerprint = Symbol.for("CommandBar::fingerprint"), t._userProperties = Symbol.for("CommandBar::userProperties"), t._eventSubscriptions = Symbol.for("CommandBar::eventSubscriptions"), t._metaAttributes = Symbol.for("CommandBar::metaAttributes"), t._updateEditorRoute = Symbol.for("CommandBar::updateEditorRoute"), t._startDebug = Symbol.for("CommandBar::startDebug"), t._stopDebug = Symbol.for("CommandBar::stopDebug"), t._shareTrackedEvents = Symbol.for("CommandBar::shareTrackedEvents"), t._setThemeV2 = Symbol.for("CommandBar::setThemeV2"), t._showWidgetTableau = Symbol.for("CommandBar::showWidgetTableau");
      },
      314: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.dispose = t.isDisposed = t.isDisposable = void 0;
        var o = r(207),
          n = function (e) {
            return void 0 !== e && void 0 !== e.dispose;
          },
          i = function (e) {
            return void 0 !== e && void 0 !== e[o._dispose];
          };
        t.isDisposable = function (e) {
          return void 0 === e || n(e) || i(e);
        }, t.isDisposed = function (e) {
          return void 0 === e || n(e) && !0 === e._disposed || i(e) && !0 === e[o._disposed];
        }, t.dispose = function (e) {
          void 0 !== e && (i(e) ? e[o._dispose]() : e.dispose());
        };
      },
      111: (e, t, r) => {
        "use strict";

        var o = r(666);
        e.exports = function (e) {
          if ("function" != typeof e) return !1;
          if (!hasOwnProperty.call(e, "length")) return !1;
          try {
            if ("number" != typeof e.length) return !1;
            if ("function" != typeof e.call) return !1;
            if ("function" != typeof e.apply) return !1;
          } catch (e) {
            return !1;
          }
          return !o(e);
        };
      },
      617: (e, t, r) => {
        "use strict";

        var o = r(102),
          n = {
            object: !0,
            function: !0,
            undefined: !0
          };
        e.exports = function (e) {
          return !!o(e) && hasOwnProperty.call(n, typeof e);
        };
      },
      307: (e, t, r) => {
        "use strict";

        var o = r(111),
          n = /^\s*class[\s{/}]/,
          i = Function.prototype.toString;
        e.exports = function (e) {
          return !!o(e) && !n.test(i.call(e));
        };
      },
      666: (e, t, r) => {
        "use strict";

        var o = r(617);
        e.exports = function (e) {
          if (!o(e)) return !1;
          try {
            return !!e.constructor && e.constructor.prototype === e;
          } catch (e) {
            return !1;
          }
        };
      },
      102: e => {
        "use strict";

        e.exports = function (e) {
          return null != e;
        };
      }
    },
    t = {};
  function r(o) {
    var n = t[o];
    if (void 0 !== n) return n.exports;
    var i = t[o] = {
      exports: {}
    };
    return e[o].call(i.exports, i, i.exports, r), i.exports;
  }
  return r.d = (e, t) => {
    for (var o in t) r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
      enumerable: !0,
      get: t[o]
    });
  }, r.g = function () {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e) {
      if ("object" == typeof window) return window;
    }
  }(), r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), r.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r(14);
})());